import { z } from 'zod';
import { PaginarSchema } from '../comum/paginacao';

export const ListarAuditoriaSchema = PaginarSchema.extend({
  usuarioId: z.string().optional(),
  maquinaId: z.string().optional(),
  acao: z.string().max(80).optional(),
  desde: z.iso.datetime().optional(),
  ate: z.iso.datetime().optional(),
});
export type ListarAuditoria = z.infer<typeof ListarAuditoriaSchema>;

export const EventoAuditoriaSchema = z.object({
  id: z.string(),
  usuarioId: z.string().nullable(),
  maquinaId: z.string().nullable(),
  acao: z.string(),
  alvo: z.string().nullable(),
  detalhes: z.unknown().nullable(),
  ip: z.string().nullable(),
  agente: z.string().nullable(),
  criadoEm: z.iso.datetime(),
});
export type EventoAuditoria = z.infer<typeof EventoAuditoriaSchema>;

/**
 * Campos que nunca entram no registro de auditoria, em qualquer nível do
 * corpo. A comparação é por conter o trecho, então `senhaAtual`, `novaSenha` e
 * `confirmacaoSenha` também caem aqui.
 */
export const CAMPOS_REDIGIDOS = [
  'senha',
  'token',
  'totp',
  'codigo',
  'segredo',
  'secret',
  'authorization',
  'cookie',
  /*
    As duas grafias de "chave de API" (F16). O campo da rota da chave do
    OpenCode se chama `segredo` justamente para cair na regra de cima; estas
    duas existem para o dia em que alguém mandar `apiKey` ou `api_key` num
    corpo — a comparação é por CONTER o trecho em minúsculas, então `apiKey`,
    `openrouterApiKey` e `api_key_nova` caem todas aqui.
  */
  'apikey',
  'api_key',
] as const;
